import { matchSorter } from 'match-sorter';

export function fuzzyTextFilterFn(rows: any, id: any, filterValue: any) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return matchSorter<row>(rows, filterValue, { keys: [(row) => row.values[id]] });
}
